<template>
  <div class="min-h-screen">
    <NavBar :signed-in="signedIn" :user-name="userName" active-page="" />

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 class="text-2xl font-bold text-gray-900 mb-6">{{ t('data_deletion.title') }}</h1>

      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-4">
        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('data_deletion.how_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('data_deletion.how_text') }}</p>
          <ol class="mt-3 text-sm text-gray-600 list-decimal list-inside space-y-2">
            <li>{{ t('data_deletion.step_1') }}</li>
            <li>{{ t('data_deletion.step_2') }}</li>
            <li>{{ t('data_deletion.step_3') }}</li>
          </ol>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('data_deletion.what_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('data_deletion.what_text') }}</p>
          <ul class="mt-2 text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('data_deletion.data_profile') }}</li>
            <li>{{ t('data_deletion.data_messages') }}</li>
            <li>{{ t('data_deletion.data_comments') }}</li>
            <li>{{ t('data_deletion.data_runs') }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('data_deletion.contact_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('data_deletion.contact_text') }}</p>
          <p class="text-sm text-blue-700 mt-1">admin@alerg.eu</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import NavBar from './NavBar.vue'

const props = defineProps({ signedIn: Boolean, userName: String })
const { t } = useI18n()
</script>
